import { useEffect, useState } from 'react';
import { Card, Space, Table, Input, Button, Descriptions, Col, Row, Flex, List, Modal, Image, Popconfirm, Alert } from 'antd';
import OrderService from "services/order"
import ProductVariantService from "services/product_variant"
import { formatCurrency } from "utils/number"
import { formatDate } from "utils/date"
import { useNavigate, useParams } from 'react-router';
import { useApp } from 'contexts/app';
import './table.css'
const service = new OrderService();
const { Search } = Input;
const OrderDetail = () => {
    const navigate = useNavigate();
    const { showLoading, prompt } = useApp();
    const [data, setData] = useState([]);
    const [customer, setCustomer] = useState({})
    const [lineItems, setLineItems] = useState([])
    const { id } = useParams();
    const [isModalPaymentProofOpen, setIsModalPaymentProofOpen] = useState(false)

    useEffect(() => {
        loadData();
    }, [id])

    const loadData = async () => {
        showLoading(true);
        var order = await service.get({ id });
        setData(order);
        setCustomer(order.customer);
        setLineItems(order.line_items);
        showLoading(false)

    }


    const onSearch = () => {

    }

    const createInvoice = async () => {
        showLoading(true);

        var data = await service.createInvoiceFile({ id: id });
        showLoading(false);
        if (data) {
            printPdf(data.invoice_file)
            //window.open(data.invoice_file, "_blank") ;
        }

    }



    const createPackingList = async () => {
        showLoading(true);

        var data = await service.createPackingListFile({ id: id });
        showLoading(false);
        if (data) {
            printPdf(data.file)
            //window.open(data.file, "_blank") ;
        }

    }

    const createShippingLabel = async () => {
        showLoading(true);

        var data = await service.createShippingLabelFile({ id: id });
        showLoading(false);
        console.log("data", data)
        if (data) {
            printPdf(data.file)
            //window.open(data.file, "_blank") ;
        }

    }

    const printPdf = (url) => {

        // window.open(url, "_blank")

        fetch(url).then(response => {

            return response.blob().then(function (myBlob) {
                var objectURL = URL.createObjectURL(myBlob);
                print(objectURL);
                // myImage.src = objectURL;
            });


            // var blob = new Blob([res], { type: 'application/pdf' });

            // var downloadUrl = URL.createObjectURL(blob);
            // print(downloadUrl);
            // console.log(blob, downloadUrl)
            // print(downloadUrl);

            // console.log("res", res)
        })

        // var iframe = document.createElement('iframe');
        // document.body.appendChild(iframe);

        // iframe.style.display = 'none';
        // iframe.onload = function () {
        //     setTimeout(function () {
        //         iframe.focus();
        //         iframe.contentWindow.print();
        //     }, 1);
        // };


        // iframe.src = url;
    }

    const print = (url) => {
        var iframe = document.createElement('iframe');
        var childNode = document.body.appendChild(iframe);

        iframe.style.display = 'none';
        iframe.onload = function () {
            setTimeout(function () {
                iframe.focus();
                iframe.contentWindow.print();
                // setTimeout(() => {
                //     document.body.removeChild(childNode);
                // }, 5000)
            }, 1);
        };


        iframe.src = url;
    }



    const cancelOrder = async () => {

        prompt({
            title: "Huỷ đơn", label: "Nhập lý do huỷ",
            onOk: async (text) => {
                await service.cancel({ id: id, reason: text });
                loadData();
            }
        });

    }

    const finishOrder = async () => {
        await service.finish({ id: id, note: "" });
        loadData();

        // prompt({
        //     title: "Hoàn tất", label: "Ghi chú",
        //     onOk: async (text) => {
        //         await service.finish({ id: id, note: text });
        //         loadData();
        //     }
        // });

    }







    return (
        <Space direction="vertical" size={16} style={{ width: "100%" }}>
            <Card>

                <Space direction="vertical" size={16} style={{ width: "100%" }}>
                    {data.status == "canceled" &&

                        <Alert
                            message="Đơn hàng này đã bị huỷ"
                            description={`Lý do huỷ: ${data.cancel.reason}`}
                            type="error"
                            closable

                        />
                    }

                    {data.status == "finalized" &&

                        <Alert
                            message="Đơn hàng này đã hoàn tất"
                            description={`Ghi chú: ${data.finalized.note}`}
                            type="success"
                            closable
                        />
                    }

                    <Descriptions >
                        <Descriptions.Item label="Mã đơn hàng">{data.id}</Descriptions.Item>
                        <Descriptions.Item label="Khách hàng">{customer.full_name}</Descriptions.Item>
                        <Descriptions.Item label="SDT">{customer.phone}</Descriptions.Item>
                        <Descriptions.Item label="Thanh toán" span={3}>{data.payment_status?.title}</Descriptions.Item>

                        <Descriptions.Item label="Địa chỉ" span={3}>
                            {data.shipping_address?.address}
                        </Descriptions.Item>
                        <Descriptions.Item label="Ghi Chú" span={3}>{data.note}</Descriptions.Item>



                    </Descriptions>

                    {data.commission &&
                        <Descriptions >
                            <Descriptions.Item label="Hoa hồng" span={3}>{formatCurrency( data.commission)}</Descriptions.Item>


                        </Descriptions>

                    }


                    <div style={{ display: "flex" }}>
                        <div>
                            <Space>
                                <Popconfirm
                                    title="Huỷ đơn hàng"
                                    description="Bạn có chắc chắn muốn huỷ đơn hàng này?"
                                    onConfirm={cancelOrder}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <Button danger >Huỷ</Button>
                                </Popconfirm>

                                <Popconfirm
                                    title="Hoàn tất"
                                    description="Bạn có chắc chắn muốn hoàn tất đơn hàng này?"
                                    onConfirm={finishOrder}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <Button  >Hoàn tất</Button>
                                </Popconfirm>
                            </Space>
                        </div>
                        <div style={{ flexGrow: 1, flexShrink: 1 }}>
                            <Flex justify='flex-end'>
                                <Space align='end' >


                                    <Button type='primary' onClick={e => navigate(`/order/edit/${id}`)}>Sửa</Button>
                                    <Button type='primary' onClick={createInvoice}>In Hoá Đơn</Button>
                                    {data.payment_proof?.image &&
                                        <Button type='primary' onClick={e => setIsModalPaymentProofOpen(true)}>Thông tin thanh toán</Button>
                                    }


                                    <Button type='primary' onClick={createPackingList}>In Phiếu Đóng Gói</Button>
                                    <Button type='primary' onClick={createShippingLabel}>In Tem Vận Chuyển</Button>
                                </Space>
                            </Flex>
                        </div>

                    </div>


                </Space>
            </Card>


            <Row gutter={16}>
                <Col span={16}>
                    <Card>
                        <table className='tbl_order' style={{ width: "100%" }}>


                            <tr>
                                <th>
                                    Sản phẩm
                                </th>
                                <th>
                                    Số lượng
                                </th>
                                <th>
                                    Đơn giá
                                </th>
                                <th>
                                    Thành tiền
                                </th>
                            </tr>

                            <tbody className='ant-table-tbody'>

                                {lineItems.map(line => {
                                    return (

                                        <tr>
                                            <td>
                                                {line.product.name} {line.variant.variant_title}
                                            </td>
                                            <td>
                                                {line.quantity}
                                            </td>
                                            <td style={{ textAlign: "right" }}>
                                                {formatCurrency(line.price)}
                                            </td>
                                            <td style={{ textAlign: "right" }}>
                                                {formatCurrency(line.amount)}
                                            </td>
                                        </tr>

                                    )
                                })}
                            </tbody>
                        </table>
                    </Card>
                </Col>
                <Col span={8} >
                    <Card>
                        <table style={{ width: "100%" }} className='tbl_order'>
                            <colgroup>
                                <col></col>
                                <col style={{ textAlign: "right" }}>
                                </col>
                            </colgroup>
                            <tbody className='ant-table-tbody'>


                                <tr>
                                    <td>
                                        Tiền hàng
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                        {formatCurrency(data.sub_amount)}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Giảm giá
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                        {formatCurrency(data.discount_amount)}
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        Mã khuyến mãi
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                        {formatCurrency(data.voucher_amount)}
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        Xu
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                        {formatCurrency(data.point_discount)}
                                    </td>
                                </tr>


                                <tr>
                                    <td>
                                        Phí ship
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                        {formatCurrency(data.shipping_amount)}
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        Tổng tiền
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                        {formatCurrency(data.total_amount)}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Card>
                </Col>
            </Row>
            <Modal title="Chuyển khoản" open={isModalPaymentProofOpen} onOk={e => setIsModalPaymentProofOpen(false)} onCancel={e => setIsModalPaymentProofOpen(false)} footer={null}>
                {data.payment_proof?.image &&
                    <>
                        <Image
                            width={250}
                            src={data.payment_proof?.image?.url}
                        />
                    </>
                }
            </Modal>
        </Space>
    )
}

export default OrderDetail;
